import React from 'react';
import styled from 'styled-components';
import * as CONSTANTS from '../constants';
import fetch from 'isomorphic-unfetch';
import Title from '../components/Title.js';
import Entries from '../components/Entries.js';
import PaginationButton from '../components/PaginationButton.js';
import { ModalContext } from '../context/modal';
import Head from 'next/head';

import { logPageView } from '../utils/analytics';

let scrollPosition = '';

const PaginationWrap = styled.div`
  width: 100%;
  overflow-y: auto;

  ${
    props => props.isVisible === true ? '' :
    props.isVisible === false ? 'height: 110px;' :
    ''
  };

  & div {
    ${
      props => props.isVisible === true ? '' :
      props.isVisible === false ? 'display: none;cursor: initial;' :
      ''
    };
  }
`;

const NoResults = styled.div`
  display: table;
  margin: 15px auto 0 auto;
  color: #888;
`;

export default class Gallery extends React.PureComponent {
  static async getInitialProps(req) {

    let queryString = '';

    if(req.query.search) {
      queryString = `?search=${req.query.search}`
    } else if(req.query.shades && req.query.tags) {
      queryString = `?tags=${req.query.tags}&shades=${req.query.shades}`;
    } else if(req.query.tags && !req.query.shades) {
      queryString = `?tags=${req.query.tags}`;
    } else if(req.query.shades && !req.query.tags) {
      queryString = `?shades=${req.query.shades}`;
    }  else {

    }

    const res = await fetch(`${CONSTANTS.API_URL}${queryString}`);
    const data = await res.json();

    let pageTitle = '';
    let phrase = undefined;

    if(req.query.search && data.entries && data.entries.length) {
      pageTitle = `<span class="withSearch">Search results for <span class="query">${req.query.search}</span> <span class="remove">&times</span></span>`;
    } else if(req.query.search && data.isSearch && !data.entries) {
      pageTitle = `<span class="withSearch">No results for <span class="query">${req.query.search}</span> <span class="remove">&times</span></span>`;
      phrase = 'Want to try searching a different phrase?';
    } else if((req.query.shades || req.query.tags) && !data.isSearch && !data.entries) {
      pageTitle = `<span class="noFilterResults">No results were found</span>`;
      phrase = 'Want to try altering your selections?';
    } else {
      pageTitle = data.pageTitle;
    }

    return {
      data: data,
      currentSearch: req.query.search || null,
      isPaginationVisible: data.hasNextPage,
      pageTitle: pageTitle,
      phrase: phrase,
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      isPaginationVisible: this.props.isPaginationVisible,
      search: this.props.currentSearch,
      entries: this.props.data.entries,
      nextPageUrl: this.props.data.nextPageUrl,
      pageTitle: this.props.pageTitle,
      phrase: this.props.phrase,
    };

    this.loadMore = this.loadMore.bind(this);
  }

  loadMore(e = undefined, isPaginationVisible = undefined) {
    if(e) {
      e.preventDefault();
    }

    if(isPaginationVisible === false) {
      return false;
    }

    const currentEntries = this.context.currentSearch === 'resetToOriginalEntries' ? [] : this.state.entries;
    
    this.setState({ 
      isPaginationVisible: false,
    });

    let nextPageUrl = this.context.currentSearch === 'resetToOriginalEntries' ? 'https://things.sitesee.co/data/page:1' : this.state.nextPageUrl;

    if(this.context.currentSearch === 'resetToOriginalEntries') {
      this.context.updateValue('nextPageLink', undefined);

      this.setState({ 
        pageTitle: 'SiteSee is a curated gallery of beautiful, modern websites.',
      });
    }

    if (this.context.nextPageLink && this.context.currentSearch !== 'resetToOriginalEntries') {
      nextPageUrl = this.context.nextPageLink;

      this.context.updateValue('nextPageLink', undefined);
    }

    this.context.updateValue('currentSearch', undefined);

    const urlForAnalytics = nextPageUrl.replace('https://things.sitesee.co/data', '');

    logPageView(urlForAnalytics);
    
    fetch(nextPageUrl).then(function(response) {
      scrollPosition = window.pageYOffset;

      return response.json();
    }).then(function(myJson) {
        window.scrollTo(0, scrollPosition);

        const newEntries = myJson.entries;

        //if(currentEntries) {
          const allEntries = [...currentEntries, ...newEntries];
          
          this.setState({ 
            isPaginationVisible: myJson.nextPageUrl ? true : false,
            nextPageUrl: myJson.nextPageUrl,
            entries: allEntries,
          });
        //}
    }.bind(this));
  }

  componentWillUnmount() {
    this.setState({
      entries: [],
    });
  }

  render() {
    let entries;

    if(this.context.currentSearch && this.context.currentSearch === 'resetToOriginalEntries') {
      this.loadMore();
    } else if(this.context.currentSearch && this.context.currentSearch !== 'resetToOriginalEntries') {
      entries = this.context.currentSearch.entries;

      this.setState({
        entries: entries,
      });
    } else {
      entries = this.state.entries;
    }

    let title = this.state.pageTitle;
    let phrase = '';
    let allowDismiss = false;

    if(this.context.currentSearch && this.context.currentSearch.searchQuery && entries && entries.length) {
      title = `<span class="withSearch">Search results for <span class="query">${this.context.currentSearch.searchQuery}</span> <span class="remove">&times</span></span>`;
      allowDismiss = true;
    } else if(this.context.currentSearch && this.context.currentSearch.isSearch && !entries) {
      title = `<span class="withSearch">No results for <span class="query">${this.context.currentSearch.searchQuery}</span> <span class="remove">&times</span></span>`;
      phrase = 'Want to try searching a different phrase?';
      allowDismiss = true;
    } else if(this.context.currentSearch && !this.context.currentSearch.isSearch && !entries) {
      title = `<span class="noFilterResults">No results were found</span>`;
      phrase = 'Want to try altering your selections?';
      allowDismiss = false;
    } else if(this.context.currentSearch) {
      title = 'SiteSee is a curated gallery of beautiful, modern websites.';
      allowDismiss = false;
    }

    const isPaginationVisible = this.context.currentSearch ? this.context.currentSearch.hasNextPage : this.state.isPaginationVisible;
      
    return (
      <React.Fragment>
        <Head>
          <title>SiteSee - Web Design Inspiration</title>
          <meta name="description" content="A curated gallery of beautiful, modern websites meant to inspire web developers and designers."></meta>
          <meta property="og:locale" content="en_US"></meta>
          <meta property="og:type" content="website"></meta>
          <meta property="og:site_name" content="SiteSee"></meta>
          <meta property="og:title" content="SiteSee"></meta>
          <meta property="og:url" content="https://sitesee.co"></meta>
          <meta property="og:image" content="https://d3alngem7je9z2.cloudfront.net/sitesee_banner.png"></meta>
          <meta property="og:description" content="A curated gallery of beautiful, modern websites meant to inspire web developers and designers."></meta>
          <meta name="twitter:card" content="summary_large_image"></meta>
          <meta name="twitter:site" content="@siteseegallery"></meta>
          <meta name="twitter:title" content="SiteSee"></meta>
          <meta name="twitter:description" content="A curated gallery of beautiful, modern websites."></meta>
          <meta name="twitter:image" content="https://d3alngem7je9z2.cloudfront.net/sitesee_banner.png"></meta>
        </Head>
        <Title title={title} hasSearch={this.props.search} allowDismiss={allowDismiss} />
        {entries ? (<Entries entries={entries} currentTime={this.props.data.currentTime} origin="index" />) : <NoResults darkMode={this.context.darkMode}>{this.props.phrase ? this.props.phrase : phrase}</NoResults>}
        <PaginationWrap onClick={(e) => this.loadMore(e, isPaginationVisible)} isVisible={isPaginationVisible}>
          <PaginationButton aria-label="Load more sites" isVisible={isPaginationVisible} text="Load more" />
        </PaginationWrap>
      </React.Fragment>
    );
  }
}

Gallery.contextType = ModalContext;
